
export default {
  props: {
    command: {type: String, required: true},
    options: {type: Object, required: true}
  },
  emits: ['delete'],
  data() {
    return {
      hover: false
    }
  },
  computed: {
    item(){
      return this.options.find(item => item.command === this.command)
    },
    type() {
      return this.item.type
    },
    title() {
      return this.item.title
    },
    icon() {
      return this.item.icon
    }
  }
}
